<ion-header>
  <ion-toolbar>
    <ion-title>System Monitoring</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="monitoring-container">
    <!-- Time Range Selector -->
    <ion-card>
      <ion-card-header>
        <ion-card-title>Time Range</ion-card-title>
      </ion-card-header>
      <ion-card-content>
        <!-- Quick time range buttons -->
        <div class="time-range-buttons">
          <ion-button size="small" fill="outline" (click)="setTimeRange(1)"
            >Last Hour</ion-button
          >
          <ion-button size="small" fill="outline" (click)="setTimeRange(6)"
            >Last 6 Hours</ion-button
          >
          <ion-button size="small" fill="outline" (click)="setTimeRange(12)"
            >Last 12 Hours</ion-button
          >
          <ion-button size="small" fill="outline" (click)="setTimeRange(24)"
            >Last 24 Hours</ion-button
          >
          <ion-button size="small" fill="outline" (click)="setTimeRange(48)"
            >Last 2 Days</ion-button
          >
          <ion-button size="small" fill="outline" (click)="setTimeRange(72)"
            >Last 3 Days</ion-button
          >
          <ion-button size="small" fill="outline" (click)="setTimeRange(168)"
            >Last Week</ion-button
          >
        </div>
      </ion-card-content>
    </ion-card>

    <!-- API Request Latency Chart -->
    <ion-card>
      <ion-card-header>
        <ion-card-title>API Request Latency</ion-card-title>
        <ion-card-subtitle
          >Response time percentiles over time</ion-card-subtitle
        >
      </ion-card-header>
      <ion-card-content>
        <div class="chart-container" *ngIf="!isLoading">
          <canvas
            baseChart
            [data]="apiLatencyChartData"
            [options]="apiLatencyChartOptions"
            type="line"
          ></canvas>
        </div>
        <div class="loading-container" *ngIf="isLoading">
          <ion-spinner></ion-spinner>
        </div>
      </ion-card-content>
    </ion-card>

    <!-- Queue Processing Latency Chart -->
    <ion-card>
      <ion-card-header>
        <ion-card-title>Queue Processing Latency</ion-card-title>
        <ion-card-subtitle
          >Oldest unacked message age by queue</ion-card-subtitle
        >
      </ion-card-header>
      <ion-card-content>
        <div class="chart-container" *ngIf="!isLoading">
          <canvas
            baseChart
            [data]="queueLatencyChartData"
            [options]="queueLatencyChartOptions"
            type="line"
          ></canvas>
        </div>
        <div class="loading-container" *ngIf="isLoading">
          <ion-spinner></ion-spinner>
        </div>
      </ion-card-content>
    </ion-card>
  </div>
</ion-content>
